
<template>
  <div class="card-switch">
    <div
      class="switch-item"
      :class="selectedCard === item ? 'active-item' : ''"
      @click="selectedCard = item"
      v-for="item of switchItems"
      :key="item"
    >
      <img
        v-if="selectedCard === item"
        src="../../icons/dod/lines-active.svg"
      />
      <img v-else src="../../icons/dod/lines-not-active.svg" alt="" />
      <div>
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardSectionSwitch",
  props: ["switchItems", "selected"],
  emits: ["cardChanged"],
  mounted() {
    this.selectedCard = this.selected;
  },
  data: () => {
    return {
      selectedCard: "",
    };
  },
  watch: {
    selectedCard() {
      this.handleCardSwitch();
    },
  },
  methods: {
    handleCardSwitch() {
      this.$emit("cardChanged", this.selectedCard);
    },
  },
};
</script>

<style scoped>
.card-switch {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid rgba(9, 7, 65, 0.25);
}
.switch-item {
  display: flex;
  gap: 1rem;
  width: 33%;
  cursor: pointer;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  border-bottom: 2px solid #fff;
}
.active-item {
  color: #e2037e;
  border-bottom: 2px solid #e2037e;
}
</style>